import type { SVGProps } from "react";
export function Tiktok(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      fill="none"
      height={16}
      viewBox="0 0 16 16"
      width={16}
      xmlns="http://www.w3.org/2000/svg"
      data-slot="icon"
      {...props}
    >
      <path
        d="m13.6845 4.67127c-.7598 0-1.4625-.25295-2.0246-.67801-.6454-.48765-1.1112-1.20477-1.2751-2.02882-.0417-.2034-.0625-.41462-.0651-.63107h-2.17294v5.94824l-.0026 3.25709c0 .8709-.56731 1.6089-1.35062 1.8697-.229.0756-.47362.1121-.72865.0965-.3279-.0183-.63237-.1174-.90041-.2764-.56731-.339-.94985-.9545-.96026-1.6611-.01562-1.10051.87178-2.00018 1.96997-2.00018.21599 0 .42418.03651.61935.0991v-1.62462-.58153c-.20558-.03129-.41377-.04693-.62716-.04693-1.20228 0-2.32649.50068-3.13061 1.40296-.60635.68061-.97068 1.5516-1.02793 2.4643-.07286 1.197.36433 2.3365 1.21269 3.1762.12491.1226.25503.2373.39296.3442.72605.5607 1.61605.8658 2.55289.8658.21079 0 .42158-.0156.62716-.0469.87439-.1304 1.68111-.532 2.31869-1.1631.7833-.7745 1.21527-1.8045 1.22047-2.8998l-.0104-4.86601c.3721.28946.7807.52677 1.2205.71191.6818.28946 1.4053.43289 2.1469.43289v-1.58029-.58674c.0026.00261-.0052.00261-.0052.00261z"
        fill="currentColor"
      />
    </svg>
  );
}
